import { ganttSingleQueueVariants } from './GanttSingleQueue';
import { Fragment } from 'react';
import { useTimelineStore } from '../store';
import { cn } from '@nexelem/utils';
import { differenceInCalendarDays } from 'date-fns';
import { GanttConfig } from '../GanttConfig';
import { Skeleton } from '@nexelem/components';

const Config = {
  minSkeletonWidth: 60,
  maxSkeletonWidth: 500,
  gapPossibility: 0.7,
  itemsPerRow: 100,
  poolSize: 20,
};

const generateRow = () =>
  Array.from({ length: Config.itemsPerRow }, () => {
    return {
      gap: Math.random() < Config.gapPossibility ? Math.floor(Math.random() * 250) + 50 : 0,
      width:
        (Math.floor((Math.random() * (Config.maxSkeletonWidth - Config.minSkeletonWidth)) / 10) +
          Config.minSkeletonWidth / 10) *
        10,
    };
  });

const skeletonPool = Array.from({ length: Config.poolSize }, generateRow);

type GanttLoadingSkeletonProps = {
  from: Date;
  to: Date;
  rowIndex: number;
};

export const GanttLoadingSkeleton = ({ from, to, rowIndex }: GanttLoadingSkeletonProps) => {
  const currentFilter = useTimelineStore((state) => state.filters.current);

  const differenceInDays = differenceInCalendarDays(to, from) + 1;
  const totalSkeletonWidth = (24 / currentFilter.measureScale) * GanttConfig.SINGLE_ELEMENT_WIDTH * differenceInDays;
  const items = skeletonPool[rowIndex % Config.poolSize];

  return (
    <div
      className={cn('min-w-full overflow-hidden', ganttSingleQueueVariants({ isFirst: true, disabled: false }))}
      style={{ width: `${totalSkeletonWidth}px` }}
    >
      {items.map(({ gap, width }, index) => (
        <Fragment key={index}>
          <div className="shrink-0" style={{ width: `${gap}px` }} />
          <Skeleton className="h-11 shrink-0 rounded-[22px]" style={{ width: `${width}px` }} />
        </Fragment>
      ))}
    </div>
  );
};
